/** Logo oficial (ícone S + salespetro). */
export const SALESPETRO_LOGO_PATH = '/logo.svg';

/**
 * Dimensões de display do logo no AppHeader (height: 35px no CSS).
 * Usar em atributos HTML width/height para que o browser reserve o espaço
 * correto antes de carregar o SVG e não cause CLS.
 * Proporção original do viewBox: 1942×540 → scale-down para 35px de altura = ~126px de largura.
 */
export const SALESPETRO_LOGO_WIDTH = 126;
export const SALESPETRO_LOGO_HEIGHT = 35;

/** Variante simplificada (barras + texto) — só landing legada se necessário. */
export const SALESPETRO_LOGO_WORDMARK_PATH = '/logo-wordmark.svg';
